













































































































import { Component, Vue } from 'vue-property-decorator'
import request from '@/utils/request'
import PlatformConfig from '@/store/modules/config'

@Component({
  name: 'CorpUserInfo',
  components: {
  }
})

export default class extends Vue {
  private url = PlatformConfig.baseServerUrl
  private imageError:any = require('@/assets/images/image_error.png')
  private userId: any = ''
  private corpUserInfo:any = {}
  // 查询客户帐户信息
  private queryCorpUserInfo() {
    request({
      url: '/CorpUserInfo/QueryCorpUserInfoById',
      method: 'GET',
      params: { id: this.userId }
    }).then((response: any) => {
      if (response.code === 200) {
        this.corpUserInfo = response.data
        this.corpUserInfo.imageUserIdentity = this.url + this.corpUserInfo.imageUserIdentity
        this.corpUserInfo.imageBusinessLicense = this.url + this.corpUserInfo.imageBusinessLicense
      } else {
        this.showMessage(response.code, response.message, (message: any) => {})
      }
    }).catch((error: any) => {
      console.log(error)
    })
  }
  // 显示消息
  private showMessage(code: any, msg: any, callback: Function) {
    this.$message({
      showClose: true,
      message: msg,
      type: code === 200 ? 'success' : code === 203 ? 'warning' : 'error',
      onClose: (message: any) => {
        callback(message)
      }
    })
  }
  created() {
    this.userId = this.$route.params.id
    this.queryCorpUserInfo()
  }
}
